var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"type-scale-n1 flex items-center justify-start px-4 flex-shrink-0",style:(_vm.style)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }